
export default (props, inject) => {
  const yaglaaction = function (reachGoal) {
    if (!process.client) {
      return
    }
    if (!window.yaglaaction) {
      return;
    }
    window.yaglaaction(reachGoal)
  }
  inject('yaglaaction', yaglaaction)
}
